<!-- 成功案例 -->
<template>
	<div class="aboutUs">
		<div class="imgBg"></div>
		<div class="boxWidth">
			<div v-for="(item,index) in menus"  :key="index" class="aboutUsSingle">
				<h2>{{item.name}}</h2>
				<p class ="title">{{item.title2}}</p>
				<div style="display: flex; flex-wrap: wrap;">
					<div class="halfBox" v-for="item2 in  item.detailList" :key="item2.id" >
						<div class="caseListOne">
							<h3>{{ item2.name }}</h3>
							<div class="lineStyle"></div>
						</div>
						<img :src="item2.imgUrl" alt="">
					</div>
				</div>
				<div v-if="item.type == 'xr'" class="xrStyle">
					<div class="xrStyleOne" v-for="item in xr" :key="item.id">
						<img :src="item.imgSrc" alt="">
					</div>
				</div>
			</div>


		</div>
	</div>
</template>

<script>
	export default {
	  components: {},
	  data() {
	    return {
			xr:[
				{id:1,imgSrc:require('../assets/img/case/8-1.jpg')},
				{id:2,imgSrc:require('../assets/img/case/8-2.jpg')},
				{id:3,imgSrc:require('../assets/img/case/8-3.jpg')},
				{id:4,imgSrc:require('../assets/img/case/8-4.jpg')},
				{id:5,imgSrc:require('../assets/img/case/8-5.jpg')},
				{id:6,imgSrc:require('../assets/img/case/8-6.jpg')},
				{id:7,imgSrc:require('../assets/img/case/8-7.jpg')},
				{id:8,imgSrc:require('../assets/img/case/8-8.jpg')},
				{id:9,imgSrc:require('../assets/img/case/8-9.jpg')},
				{id:10,imgSrc:require('../assets/img/case/8-10.jpg')},
			]
		}
	  },
	  computed: {
			menus() {
				return this.$t('casesList'); // 获取翻译的menus
			}
		},
	  methods:{
		  
	  }
	}
</script>

<style scoped lang="scss">
 .imgBg{
	background-image: url('../assets/img/a31.jpg');
 }
 .aboutUsSingle h2{
	text-align: center;
	
  }
  p.title{
		text-align: center;
		margin-bottom:10px;
		margin-bottom: 50px;
	}
	.lineStyle{
		width:80px;
		height:2px;
		background-color:#409eff ;
		margin-top:20px;
		margin-bottom:30px;
	}
	.halfBox {
		width:48%;
		height:200px;
		overflow: hidden;
		padding:20px;
		border:1px solid #ddd;
		box-shadow: 0 0 5px #ccc;
		background-color: #fff;
		border-radius: 5px;
		margin:10px;
		position: relative;
		transition: all 0.5s;
		img{
			width:300px;
			height:200px;
			position:absolute;
			top:0px;
			right:0px;
			transition: all 0.5s;
		}
	}
  .halfBox:hover{	
	img{
		transform:scale(1.1);
	}
  }
  .caseListOne{
	h3{
		margin-top:40px;
		width:220px;
		// border:1px solid red;
	}
  }

  .xrStyle{
	display: flex;
	flex-wrap: wrap;
	.xrStyleOne{
		width:230px;
		height:150px;
		overflow: hidden;
		border-radius: 10px;
		margin:5px;
		box-shadow: 0 0 8px #000;
		img{
			width:100%;
			height:100%;
		}
	}
  }
</style>